// removed by extract-text-webpack-plugin
module.exports = {"popup":"ch7q"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Popover/Popover.scss
// module id = uo1j
// module chunks = 0